import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'truncate-see-more',
    templateUrl: './truncate-see-more.component.html',
    standalone: false
})
export class TruncateSeeMoreComponent {
	@Input() seeMoreKey: string = 'SeeMore';
	@Input() seeMoreClass: string = 'btn-a';
	@Input() showSeeMore: boolean = true;
	@Output() seeMore: EventEmitter<void> = new EventEmitter();
}
